import './Contato.css';

export default function Contato() {
  return (
    <div className="contato-page">
      <div className="contato-header">
        <h1>📞 Contato</h1>
        <p>Entre em contato conosco! Estamos sempre prontos para atendê-lo.</p>
      </div>

      <div className="contato-content">
        <div className="contato-cards">
          <div className="contato-card">
            <span className="contato-icon">📞</span>
            <h3>Telefone</h3>
            <p>(XX) XXXXX-XXXX</p>
          </div>

          <div className="contato-card">
            <span className="contato-icon">💬</span>
            <h3>WhatsApp</h3>
            <p>(XX) XXXXX-XXXX</p>
            <a
              href="https://wa.me/55XXXXXXXXXXX"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success btn-sm"
            >
              Enviar Mensagem
            </a>
          </div>

          <div className="contato-card">
            <span className="contato-icon">📧</span>
            <h3>E-mail</h3>
            <p>contato@paradapredileta.com.br</p>
          </div>

          <div className="contato-card">
            <span className="contato-icon">📱</span>
            <h3>Redes Sociais</h3>
            <div className="social-links">
              <a href="#instagram" className="social-link">📷 Instagram</a>
              <a href="#facebook" className="social-link">👍 Facebook</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
